// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1lYFR","image":"Header_image__1foA8","name":"Header_name__1_WSJ","info":"Header_info__1pivr","infoRow":"Header_infoRow__3w2Pt"};